import { IonButton, IonCard, IonCardContent, IonIcon, IonInput, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, IonSpinner } from '@ionic/react';
import { checkmarkCircle, closeCircle, restaurant } from 'ionicons/icons';
import React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { geocodeByPlaceId } from 'react-places-autocomplete';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, forwardToDeliveryOption, goBack, isEmptyObject, isWebConfig, sprintf, validateForm } from '../../lib/utils';
import { getNearestLocation, postCodeCheck, saveDeliveryDataTemporarily, setCommonModal, setDeliveryAddress, setPostCodeData, storeDeliveryAddress } from '../../store/actions';
import '../clickAndCollect/index.css';
import './index.css';
import { getEnv } from '../../lib/env';
import FieldWrapper from '../../components/fieldWrapper';

class DeliveryAddressCheck extends React.Component {
	state = {
		scriptLoaded: false,
		form: {
			addressLine1: '',
			addressLine2: '',
			place: '',
			postalCode: '',
			driverNotes: null,
			lat: '',
			lng: '',
			streetNumber: '',
			street: ''
		},
		formErrors: {},
		usePostCode: false,
		initial: true,
		checking: false,
		postalCode: '',
		address: '',
		postalCodeValid: false,
		addressValid: true,
		deliveryZone: [],
		deliveryZoneOption: '',
		deliveryPrice: '',
		restaurant: {},
		validPostCode: false,
		checkMarkFlag: null,
		minOrder: 0,
		searchOptions: {
			componentRestrictions: {
				country: getConfig().general?.defaultState || 'UK',
			},
			types: ['address'],
		},
	};

	formConfig = {
		addressLine1: { required: true },
		addressLine2: { required: false },
		place: { required: true },
	};

	handleInput = (key, val) => {
		const form = {
			...this.state.form,
			[key]: val,
		};

		this.setState({
			form,
			formErrors: validateForm(this.formConfig, form),
		});
	};

	handleChange = (address) => {
		this.setState({ address });
	};

	handleSelect = (address) => {
		this.setState({ address, showAddressText: true }, () => {
			geocodeByPlaceId(address.value.place_id)
				.then((results) => {
					const result = results[0]; // type: google.maps.GeocoderResult
					const components = result.address_components; // type: google.maps.GeocoderAddressComponent[]

					const streetNumberComponent = components.find(el => el.types.includes('street_number'));
					const routeComponent = components.find(el => el.types.includes('route'));
					const postalCodeComponent = components.find(el => el.types.includes('postal_code'));
					const cityComponent =
						components.find(el => el.types.includes('postal_town')) ||
						components.find(el => el.types.includes('locality')) ||
						components.find(el => el.types.includes('administrative_area_level_1')) ||
						components[2];

					// 1. Standard case: street_number + route
					if (streetNumberComponent && routeComponent) {
						const streetNumber = streetNumberComponent.long_name;
						const addressLine1 = `${streetNumber} ${routeComponent.long_name}`;
						this.setState({
							addressValid: true,
							isPostCode: true,
							address: result.formatted_address,
							form: {
								streetNumber: streetNumber,
								addressLine1: addressLine1,
								place: cityComponent?.long_name || '',
								postalCode: postalCodeComponent?.long_name || '',
								lat: result.geometry.location.lat(),
								lng: result.geometry.location.lng(),
								street: routeComponent.long_name
							},
						}, () => {
							this.check(postalCodeComponent?.long_name, this.props.deliveryRangeType);
						});
						return;
					}

					// 2. Premise case (e.g. building name instead of street number)
					const premiseComponent = components.find(el => el.types.includes('premise'));
					if (premiseComponent && routeComponent) {
						const addressLine1 = `${premiseComponent.long_name} ${routeComponent.long_name}`;
						this.setState({
							addressValid: true,
							isPostCode: true,
							address: result.formatted_address,
							form: {
								addressLine1: addressLine1,
								place: cityComponent?.long_name || '',
								postalCode: postalCodeComponent?.long_name || '',
								lat: result.geometry.location.lat(),
								lng: result.geometry.location.lng(),
								street: routeComponent.long_name
							},
						}, () => {
							this.check(postalCodeComponent?.long_name, this.props.deliveryRangeType);
						});
						return;
					}

					// 3. Fallback: not enough info, ask user to enter manually
					this.setState({
						address: result.formatted_address,
						addressValid: false,
						isPostCode: false,
						errorMessage: 'The address must include a street number or building name. Please try again.',
					});
				})
				.catch((error) => {
					console.error('Geocoding API Error:', error);
					this.setState({
						addressValid: false,
						isPostCode: false,
						errorMessage: 'There was an error processing the address. Please try again.',
					});
				});
		});
	};

	checkDelivery = () => {
		if (!Basket.getDeliveryOption()) {
			forwardToDeliveryOption();
		}
	};
	loadGoogleMapsScript = () => {
		if (!document.querySelector('#google-maps-script')) {
			const script = document.createElement('script');
			script.id = 'google-maps-script';
			script.src = `https://maps.googleapis.com/maps/api/js?key=${getEnv('GOOGLE_API_KEY')}&libraries=places`;
			script.async = true;
			script.defer = true;
			script.setAttribute('nonce', 'nonce-tU9QXE2MMxqhPUGR')


			script.onload = () => {
				this.setState({ scriptLoaded: true });
				console.log('Google Maps script loaded successfully');
			};

			script.onerror = () => {
				console.error('Error loading Google Maps script');
			};
			document.body.appendChild(script);
		} else {
			this.setState({ scriptLoaded: true });
		}
	};
	componentDidMount() {
		this.loadGoogleMapsScript();

		Basket.setOrderType(this.props.location?.state?.scheduled ? 'scheduled-delivery' : 'charter-delivery');
		this.checkDelivery();
	}

	componentDidUpdate(prevProps, prevState) {
		this.checkDelivery();
		if (prevState.deliveryZoneOption !== this.state.deliveryZoneOption) {
			this.setState({
				deliveryPrice: this.state.deliveryZone[this.state.deliveryZoneOption].delivery_zone.price,
			});
			const minOrder = this.state.deliveryZone[this.state.deliveryZoneOption].delivery_zone.min_order;
			Basket.setDeliveryMinOrder(minOrder);
		}
		try {
			if (this.props.nearestLocationsFetchingStarted !== prevProps.nearestLocationsFetchingStarted && !this.props.nearestLocationsFetchingStarted) {
				const copiedRestaurants = JSON.parse(JSON.stringify(this.props.restaurants));
				const filteredRestaurants = copiedRestaurants.filter((restaurant) => !restaurant.can_charter_delivery_order);
				let deliveryZone = JSON.parse(JSON.stringify(this.props.checkedCodeData)).filter((el) => filteredRestaurants.every((fd) => fd.id !== el.restaurant_id));

				if (deliveryZone[0]) {
					this.setState({ deliveryZone, restaurant: deliveryZone[0], checking: false, checkMarkFlag: 'success', postalCodeValid: true, }, () => {
						Basket.setDeliveryPrice(deliveryZone[0].delivery_zone.price)
						Basket.setDeliveryMinOrder(deliveryZone[0].delivery_zone.min_order);
						if (!this.props.location?.state?.scheduled) {
							if (this.state.usePostCode) {
								this.saveAndContinue()
							} else {
								this.saveAddressAndContinue()
							}
						}

					})
				} else {
					this.setState({ checking: false, postalCodeValid: false, checkMarkFlag: 'danger' });
				}


			}
		}
		catch (err) {
			console.log(err)
		}

	}

	checkPostCode = (value) => {
		// let reg = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/
		// let postalCodeValid = reg.test(value)
		if (value.length >= 3) {
			this.setState({
				postalCodeValid: true,
				postalCode: value,
				initial: false,
				checkMarkFlag: null,
			});
		} else {
			this.setState({ postalCodeValid: false, postalCode: value, initial: false, checkMarkFlag: null }, () => {
				this.props.dispatch(setPostCodeData({ data: [] }));
			});
		}
	};

	setPostalCode = (e) => {
		this.checkPostCode(e.target.value);
	};

	check = (value, type) => {
		const { form, postalCode } = this.state;
		const tempData = {
			addressLine1: form.addressLine1,
			place: form.place,
			postalCode,
		};
		if (form.addressLine2) {
			tempData.addressLine2 = form.addressLine2;
		}

		let charterDelivery = false;
		if (Basket.delivery_option.id === 'charter-delivery') {
			charterDelivery = true;
		}
		if (type === 'postcode') {
			this.props.dispatch(postCodeCheck(value, charterDelivery));
			this.props.dispatch(saveDeliveryDataTemporarily(tempData));
			this.setState({ initial: false, checking: true });
		} else if (type === 'distance' || type === 'polygon') {
			const formattedAddress = this.state.address.length > 0 ? this.state.address : `${form.addressLine1}, ${form.addressLine2}, ${form.place}, ${postalCode}`;
			this.props.dispatch(getNearestLocation(formattedAddress, charterDelivery, Basket.delivery_option.id == 'scheduled-delivery'));
			this.props.dispatch(saveDeliveryDataTemporarily(tempData));
			this.setState({ initial: false, checking: true, restaurant: {}, deliveryPrice: '' });
		} else {
			this.setState({ initial: true }, () => {
				this.props.dispatch(setPostCodeData({ data: [] }));
				this.props.dispatch(saveDeliveryDataTemporarily(tempData));
			});
		}
		this.setState({
			initial: false,
			checking: true,
			formErrors: validateForm(this.formConfig, this.state.form),
		});
	};

	saveAndContinue = () => {
		const { postalCode, restaurant } = this.state;
		const { restaurants } = this.props;
		const minOrder = restaurant.delivery_zone.min_order;
		this.props.dispatch(setDeliveryAddress({ postalCode: postalCode.toUpperCase() }));
		Basket.setRestaurant(restaurants.find((res) => res.id === restaurant.restaurant_id));
		if (!this.props.location?.state?.saveOrderData) {
			if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes(this.props.location?.state?.scheduled ? 'scheduled-delivery' : 'delivery')) {
				if (getConfig().flags.applyAutomaticServiceCharge) {
					if (Basket.getRestaurantServiceCharge()) {
						const service_charge_original = Basket.getRestaurantServiceCharge();
						Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
					} else {
						const defaultServiceCharge =
							typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
						if (defaultServiceCharge) {
							Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
						}
					}
				} else {
					Basket.setServicePercentage(0);
				}
			} else {
				Basket.setServicePercentage(0);
			}
		}

		this.props.dispatch(storeDeliveryAddress(this.state.form));
		Basket.setDeliveryAddress({ ...this.state.form, postalCode: postalCode });
		Basket.setDeliveryMinOrder(minOrder);
		forwardTo('/delivery-address-add', {
			scheduled: this.props.location?.state?.scheduled ? true : false,
			checkedCodeData: this.props.checkedCodeData

		});
	};


	saveAddressAndContinue = () => {
		const { restaurants } = this.props;
		const { restaurant } = this.state;

		Basket.setDeliveryAddress(this.state.form);
		Basket.setRestaurant(restaurants.find((res) => res.id === restaurant.restaurant_id));
		if (!this.props.location?.state?.saveOrderData) {
			if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes(this.props.location?.state?.scheduled ? 'scheduled-delivery' : 'charter-delivery')) {
				if (getConfig().flags.applyAutomaticServiceCharge) {
					if (Basket.getRestaurantServiceCharge()) {
						const service_charge_original = Basket.getRestaurantServiceCharge();
						Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
					} else {
						const defaultServiceCharge =
							typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
						if (defaultServiceCharge) {
							Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
						}
					}
				} else {
					Basket.setServicePercentage(0);
				}
			} else {
				Basket.setServicePercentage(0);
			}
		}
		forwardTo('/delivery-address-add', {
			checkedCodeData: this.props.checkedCodeData,
			scheduled: this.props.location?.state?.scheduled ? true : false
		});
	};

	restaurantName = (restaurant) => {
		if (restaurant && restaurant.restaurant_id) {
			return restaurant.restaurant_name;
		}
		return '';
	};

	restaurantAddress = (restaurant) => {
		if (restaurant && restaurant.restaurant_id) {
			return restaurant.restaurant_address;
		}
		return '';
	};
	proceedToOrder = (id) => {
		this.setState({
			deliveryZoneOption: id,
			error: '',
			restaurant: this.state.deliveryZone[id],
		}, () => {
			if (this.state.usePostCode) {
				this.saveAndContinue()
			} else {
				this.saveAddressAndContinue()
			}
		})
	};
	changeDeliveryZone = (event) => {
		this.setState({
			deliveryZoneOption: event.detail.value,
			error: '',
			restaurant: this.state.deliveryZone[event.detail.value],
		});
	};
	setDeliveryPrice = () => {
		let option = this.state.deliveryZoneOption;
		let deliveryPrice = this.props.checkedCodeData[option].delivery_zone.price;
		this.setState({ deliveryPrice, restaurant: this.props.checkedCodeData[option] }, () => {
			this.props.dispatch(setCommonModal('isChooseDeliveryModalOpen', false));
		});
	};
	checkAvailableSlotsForToday = (restaurant) => {
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let today = days[moment().format('d')];
		const day = {
			Monday: 'w1',
			Tuesday: 'w2',
			Wednesday: 'w3',
			Thursday: 'w4',
			Friday: 'w5',
			Saturday: 'w6',
			Sunday: 'w0',
		};
		let selectedRestaurant = this.props.restaurants.find((r) => r.id === restaurant.restaurant_id);
		let deliveryTimes = selectedRestaurant.charter_delivery_times_json;

		let flag = false;
		if (!isEmptyObject(deliveryTimes)) {
			for (let i = 0; i < deliveryTimes.length; i++) {
				deliveryTimes[i].availability.forEach((dt) => {
					if (dt.d === day[today] && dt?.active !== false) {
						let addedTime = null;
						addedTime = moment().add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
						if (addedTime.isBefore(moment(dt.end, 'hh:mm'))) {
							flag = true;
						}
					}
				});
			}
		}
		return flag;
	};
	getAddressString(form) {
		return [form?.addressLine1, form?.addressLine2, form?.place, this.state.postalCode].filter(Boolean).join(', ');
	}
	backHandler = () => {
		const { address_list } = this.props.profile;
		if (address_list && address_list.length > 0) {
			goBack();
		} else {
			forwardTo('/delivery-options');
		}
	};
	formatGoogleMapResponse = (results) => {
		const formatedResponse = {};
		if (results && results[0]?.address_components && results[0].address_components.length > 0) {
			results[0].address_components.map((el) => {
				if (el.types.includes('postal_town')) {
					formatedResponse.postal_town = el.long_name;
				} else if (el.types.includes('street_number')) {
					formatedResponse.street_number = el.long_name;
				} else if (el.types.includes('route')) {
					formatedResponse.route = el.long_name;
				} else if (el.types.includes('neighborhood')) {
					formatedResponse.neighborhood = el.long_name;
				} else if (el.types.includes('postal_code')) {
					formatedResponse.postal_code = el.long_name;
				}
			});
		}
		return formatedResponse;
	}

	render() {
		const { __, checkedCodeData, isChooseDeliveryModalOpen, deliveryRangeType } = this.props;
		const {
			initial,
			checking,
			postalCode,
			address,
			postalCodeValid,
			deliveryZone,
			deliveryZoneOption,
			deliveryPrice,
			checkMarkFlag,
			searchOptions,
			addressValid,
			form,
			formErrors,
			usePostCode,
		} = this.state;
		const animationMenuClass = isChooseDeliveryModalOpen ? 'show-up' : '';
		let formValid = Object.keys(formErrors).length === 0;

		return (
			<Layout showLoginIcon={getConfig().flags.hasGuestCheckout && Basket.itemsCount() == 0} backHandler={this.backHandler} title={__('Add new address')} headerWithTitle={true} color="transparent">
				{this.state.scriptLoaded &&
					<>
						<div className="absolute-content flex-row-wrapper"></div>
						{/* <IonCard color="white" className="restaurant-card scrollable-y"> */}
						{/* <IonCardContent className="flex-row-wrapper "> */}
						<Title className="web-only page-title-centered">{__('Add new address')}</Title>
						<div>
							{this.state.usePostCode ? (
								<>
									{this.state.deliveryZone.length === 0 || this.state.showFullForm ? (
										<form autoComplete="on">
											<div className="input-field-container">
												<StrongText>{__('Address 1')}</StrongText>
												<FieldWrapper error={formErrors.addressLine1}>
													<IonInput
														required={true}
														value={form?.addressLine1}
														autocomplete="street-address"
														onIonInput={(e) => this.handleInput('addressLine1', e.target.value, e)}
														type="text"
														clearInput
													/>
												</FieldWrapper>
											</div>

											<div className="input-field-container">
												<StrongText>{__('Address 2')}</StrongText>
												<FieldWrapper error={formErrors.addressLine2}>
													<IonInput
														value={form?.addressLine2}
														autocomplete="street-address"
														onIonInput={(e) => this.handleInput('addressLine2', e.target.value, e)}
														type="text"
														clearInput
													/>
												</FieldWrapper>
											</div>

											<div className="input-field-container">
												<StrongText>{__('Town')}</StrongText>
												<FieldWrapper error={formErrors.place}>
													<IonInput
														required={true}
														value={form?.place}
														autocomplete="on"
														onIonInput={(e) => this.handleInput('place', e.target.value, e)}
														type="text"
														clearInput
													/>
												</FieldWrapper>
											</div>

											<div className="input-field-container">
												<StrongText>{__('Postcode')}</StrongText>
												<FieldWrapper>
													<IonInput
														required={true}
														value={postalCode?.toUpperCase()}
														autocomplete="postal-code"
														onIonInput={(e) => this.setPostalCode(e)}
														type="text"
													/>
												</FieldWrapper>
											</div>
										</form>
									) : (
										<div className="input-field-container">
											<StrongText>{__('Delivery to')}</StrongText>
											<IonItem
												onClick={() => {
													this.setState({ deliveryZone: [] });
												}}
												lines="none"
												className="input-field-wrapper"
											>
												<IonInput value={this.getAddressString(form)} readonly={true} />
											</IonItem>
										</div>
									)}
								</>
							) : (
								<>
									<StrongText>{__('Find your full address')}</StrongText>
									<Spacer size={2} />
									{this.state.showAddressText ? (
										<IonItem lines="none" className="input-field-wrapper ">
											<IonInput
												type="text"
												pattern="text"
												inputmode="text"
												value={address?.label ?? address}
												onFocus={() => this.setState({ showAddressText: false })}
											></IonInput>
										</IonItem>
									) : (
										<div className="input-field-wrapper">
											<GooglePlacesAutocomplete
												autocompletionRequest={{
													componentRestrictions: {
														country: [getConfig().general.defaultState || 'UK'],
													},
												}}
												selectProps={{
													value: address,
													onChange: (address) => this.handleSelect(address),
													placeholder: `${__('Search Places')} ...`,
													className: 'location-search-input',
													noOptionsMessage: () => {
														// If no input, show initial message, otherwise show "No options"
														return __('No options available');
													},
													styles: {
														input: (provided) => ({
															...provided,
														}),
														option: (provided, state) => ({
															...provided,
															cursor: 'pointer',
														}),
													},
												}}
											/>
										</div>
									)}
								</>
							)}
							{this.state.usePostCode ? (
								<>
									{this.state.deliveryZone.length === 0 && (
										<IonButton
											color='secondary'
											className="link"

											onClick={() => {
												this.setState({
													usePostCode: false,
												});
											}}
										>
											{__('Check by address')}
										</IonButton>
									)}
								</>
							) : this.state.deliveryZone.length === 0 ? (
								<>
									{(!getConfig().flags.hasDriverBooking && !getConfig().flags.hasUberDriverBooking) &&
										<>
											<Spacer size={5} />

											<IonButton
												color='secondary'

												className="link "

												onClick={() => {
													this.setState({
														usePostCode: true,
														formErrors: {},
														addressValid: true,
														address: '',
														form: {
															addressLine1: '',
															addressLine2: '',
															place: '',
															postalCode: '',
															driverNotes: null,
															lat: '',
															lng: '',
															streetNumber: '',
															street: ''
														},
													});
												}}
											>
												{__('Address not listed?')}
											</IonButton>
										</>
									}
								</>

							) : null}
							<Spacer size={5} />
							<div className="address-checking-box ">
								{!addressValid ? (
									<>
										<NormalText color="danger">{sprintf(__('Please write the full address in correct form including number'), 'small')}</NormalText>
										{!usePostCode && !getConfig().flags.hasDriverBooking && !getConfig().flags.hasUberDriverBooking && (
											<>
												<Spacer size={5} />
												<IonButton
													className="ion-margin-top"
													expand="block"
													color="primary"
													onClick={() => {
														this.setState({
															usePostCode: true,
															formErrors: {},
															addressValid: true,
															address: '',
															form: {
																addressLine1: '',
																addressLine2: '',
																place: '',
																postalCode: '',
																driverNotes: null,
																lat: '',
																lng: '',
																streetNumber: '',
																street: ''
															},
														});
													}}
												>
													{__('Enter Address Manually')}
												</IonButton>
											</>
										)}
									</>
								) : null}
								{initial ? null : checking ? (
									<>
										<br />
										<div>
											<IonSpinner />
										</div>
										<SmallText>{__('Checking nearest locations')}</SmallText>
									</>
								) : postalCodeValid && checkedCodeData.length > 0 && addressValid ? (
									!checkMarkFlag ? null : (
										<>
											<IonList lines="none" className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper' : 'box-wrapper'}`}>
												<IonRadioGroup onIonChange={this.changeDeliveryZone} value={deliveryZoneOption}>
													{deliveryZone
														.sort((a, b) => {
															return a.delivery_zone.price - b.delivery_zone.price;
														})
														.map((restaurant, i) => {
															const { restaurant_name, restaurant_address, delivery_zone, restaurant_id } = restaurant;
															const image = this.props.restaurants.find(el => el.id == restaurant_id)?.image || ''

															const price = restaurant.delivery_zone.price;
															let availableSlosts = this.checkAvailableSlotsForToday(restaurant);

															return (
																<React.Fragment key={`restaurant_${i}`}>
																	{getConfig().general.tiledRestaurantView ?
																		<IonItem
																			className="pointer box-wrapper"
																			disabled={!availableSlosts}
																			onClick={() => this.proceedToOrder(i)}
																			lines="none"
																			key={i}
																		>
																			<div style={{ width: '100%' }}>
																				<img src={image} />
																				<div>
																					<StrongText className='block text-to-update'>{__(restaurant_name)}</StrongText>
																					<div className="restaurant-data" >
																						{!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
																							<>
																								<SmallText className='block'>

																									{price > 0
																										? restaurant?.delivery_charge_in_percent
																											? `${__('Delivery price')} -  ${price}%`
																											: `${__('Delivery price')} - ${Basket.formatPrice(price)}`
																										: `${__('Free Delivery')}`}
																								</SmallText>

																								<SmallText className="block">
																									{__('Minimun Order')} - {Basket.formatPrice(delivery_zone.min_order)}
																								</SmallText>
																							</>
																						)}
																					</div>
																				</div>
																				<SmallText className="restaurant-status" >{!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}</SmallText>
																			</div>
																		</IonItem> :
																		<IonItem key={i} lines='none' className='restaurant-wrapper'>
																			<div tabIndex="-1"></div>
																			<IonRadio disabled={!availableSlosts} color='primary' slot="start" value={i} />
																			<IonLabel className="ion-text-wrap" color="dark">
																				<StrongText className='block text-to-update'>{restaurant_name}</StrongText>
																				<SmallText className="block">{restaurant_address}</SmallText>
																				<div className="delivery-additional-restaurant-information">
																					{!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
																						<div>
																							{price > 0 ? (
																								<SmallText>
																									{__('Delivery charge')} - {Basket.formatPrice(price)}
																								</SmallText>
																							) : (
																								<SmallText>{__('Free Delivery')}</SmallText>
																							)}
																							<SmallText className="block">
																								{__('Minimun Order')} - {Basket.formatPrice(delivery_zone.min_order)}
																							</SmallText>
																						</div>
																					)}
																					<SmallText className="restaurant-opening-time">
																						{' '}
																						{!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}
																					</SmallText>
																				</div>
																			</IonLabel>
																		</IonItem>
																	}</React.Fragment>
															);
														})}
												</IonRadioGroup>
											</IonList>
										</>
									)
								) : checkedCodeData.length === 0 && checkMarkFlag && addressValid ? (
									<>
										<Spacer size={1} />
										<SmallText color="danger centered">{__('Unfortunately, we do not deliver to you yet')}</SmallText>
										{!usePostCode && !getConfig().flags.hasDriverBooking && !getConfig().flags.hasUberDriverBooking && (
											<IonButton
												expand="block"
												className="ion-margin-top"
												color="primary"
												onClick={() => {
													this.setState({
														usePostCode: true,
														formErrors: {},
														addressValid: true,
														address: '',
														form: {
															addressLine1: '',
															addressLine2: '',
															place: '',
															postalCode: '',
															driverNotes: null,
															lat: '',
															lng: '',
															streetNumber: '',
															street: ''
														},
													});
												}}
											>
												{__('Enter Address Manually')}
											</IonButton>
										)}
									</>
								) : null}
							</div>
						</div>
						<Spacer size={5} />
						<div className="flex-min">
							{postalCodeValid && this.state.deliveryZone.length > 0 && checkMarkFlag && addressValid ? (
								<>
									{!getConfig().general.tiledRestaurantView &&
										<>
											{
												this.state.usePostCode ? (
													<IonButton className='button-uppercase' disabled={!postalCodeValid || deliveryPrice === '' || !formValid} expand="block" color="primary" onClick={this.saveAndContinue}>
														{__('Continue')}
													</IonButton>
												) : (
													<IonButton className='button-uppercase' disabled={!postalCodeValid || deliveryPrice === ''} expand="block" color="primary" onClick={this.saveAddressAndContinue}>
														{__('Save address and Continue')}
													</IonButton>
												)
											}
										</>
									}

								</>
							) : this.state.usePostCode ? (
								<IonButton
									className="no-margin"
									disabled={!postalCodeValid || !formValid || form.addressLine1 == '' || form.place == ''}
									expand="block"
									color="primary"
									onClick={() => {
										this.check(postalCode, deliveryRangeType);
									}}
								>
									{__('Check Postcode')}
								</IonButton>
							) : null}
						</div>

						<div
							className="click-collect-pickers-backdrop"
							style={{ display: isChooseDeliveryModalOpen ? '' : 'none' }}
							onClick={() => this.props.dispatch(setCommonModal('isChooseDeliveryModalOpen', false))}
						></div>
						<div className={`click-collect-dialog ${animationMenuClass}`}>
							<div className="click-collect-dialog-layout sc-ion-modal-md">
								<div className="click-collect-dialog-header">
									<h3>{__('Choose delivery')}</h3>
								</div>
								<div
									className="click-collect-dialog-closer"
									style={{ position: 'absolute', right: 0, top: 0 }}
									onClick={() => this.props.dispatch(setCommonModal('isChooseDeliveryModalOpen', false))}
								>
									<ion-icon name="close" role="img" class="md hydrated" aria-label="close"></ion-icon>
								</div>
								<div className="click-collect-dialog-content">
									<IonList lines="full" className="box-wrapper">
										<IonRadioGroup onIonChange={this.changeDeliveryZone} value={deliveryZoneOption}>
											{deliveryZone
												.sort((a, b) => {
													return a.delivery_zone.price - b.delivery_zone.price;
												})
												.map((restaurant, i) => {
													const { restaurant_name } = restaurant;
													const price = restaurant.delivery_zone.price;
													return (
														<IonItem key={i} lines="none">
															<div tabIndex="-1"></div>
															<IonRadio color='primary' slot="start" value={i} />
															<IonLabel className="ion-text-wrap" >
																{price > 0
																	? `${restaurant_name}
                                ${__('Delivery price')} - ${Basket.formatPrice(price)}`
																	: `${restaurant_name} - ${__('Free Delivery')}`}
															</IonLabel>
														</IonItem>
													);
												})}
										</IonRadioGroup>
									</IonList>
								</div>
								<div className="click-collect-dialog-action">
									<IonButton
										disabled={deliveryZoneOption === ''}
										expand="block"
										color="primary"
										onClick={() => {
											this.setDeliveryPrice();
										}}
									>
										{__('Continue')}
									</IonButton>
								</div>
							</div>
						</div>
					</>}

			</Layout>
		);
	}
}

const stateToProps = (state) => {
	const { profile, auth } = state.profile;
	const { checkedCodeData } = state.orders;
	const { deliveryRangeType, isChooseDeliveryModalOpen, nearestLocationsFetchingStarted } = state.common;
	const { restaurants } = state.restaurants;
	return {
		profile,
		auth,
		checkedCodeData,
		deliveryRangeType,
		isChooseDeliveryModalOpen,
		restaurants,
		nearestLocationsFetchingStarted
	};
};

export default connect(stateToProps)(withTranslation(DeliveryAddressCheck));
